import styled from 'styled-components';
import { formTokens, createButtonStyles } from '../../../../../styles/tokens/forms';

// Photo Upload Area
export const PhotoUploadArea = styled.div`
  border: 2px dashed ${formTokens.colors.border};
  border-radius: ${formTokens.borderRadius.md};
  padding: ${formTokens.spacing.xxl};
  margin-bottom: ${formTokens.spacing.xxl};
  text-align: center;
  background-color: ${formTokens.colors.background.upload};
  transition: ${formTokens.transitions.all};
  cursor: pointer;
  
  &:hover {
    border-color: ${formTokens.colors.primary};
    background-color: ${formTokens.colors.background.uploadHover};
  }
`;

export const PhotoUploadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${formTokens.spacing.lg};
`;

export const UploadIcon = styled.div`
  width: 48px;
  height: 48px;
  color: ${formTokens.colors.textPlaceholder};
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const UploadText = styled.p`
  color: ${formTokens.colors.textMuted};
  font-size: ${formTokens.typography.fontSizes.base};
  margin: 0;
`;

export const BrowseButton = styled.button`
  ${createButtonStyles('primary')}
  padding: ${formTokens.spacing.md} ${formTokens.spacing.xl};
`;

export const FileInfo = styled.p`
  color: ${formTokens.colors.textMuted};
  font-size: ${formTokens.typography.fontSizes.xs};
  margin: 0;
`;

// Loading Styles
export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid ${formTokens.colors.background.secondary};
  border-top: 2px solid ${formTokens.colors.primary};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: ${formTokens.spacing.sm};
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const FormSectionLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${formTokens.spacing.lg};
  color: ${formTokens.colors.textMuted};
  font-size: ${formTokens.typography.fontSizes.sm};
  background: ${formTokens.colors.background.secondary};
  border-radius: ${formTokens.borderRadius.md};
  margin: ${formTokens.spacing.sm} 0;
`;

// Button Container and Buttons
export { ButtonContainer } from '../../shared/styles/form.styles';

